import React from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import { MUIcon } from '@platform/shared/ui';
// import DefaultMapPicker from '../DefaultMaps/DefaultMapPicker';
import ProjectsPicker from '../Projects/ProjectsPicker';
import { Modal } from '../shared';
import useCreateStory from './useCreateStory';

type Inputs = {
  title: string;
  projectId: string;
  defaultMapId: string;
};

interface Props {
  defaultProjectId?: string;
  mapContextId: string;
  thumb?: string;
  onCloseRequest?: () => void;
}

const CreateStoryModal: React.FC<Props> = ({ defaultProjectId, mapContextId, thumb, onCloseRequest }) => {
  const { create, isCreating } = useCreateStory();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<Inputs>({ defaultValues: { title: '', projectId: defaultProjectId, defaultMapId: undefined } });

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    create({ ...data, mapContextId });
  };

  const title = (
    <div className="flex items-start justify-center gap-4">
      <div>
        <div className="bg-acai flex h-[40px] w-[40px] items-center justify-center rounded-[999px]">
          <MUIcon name="note_stack" className="text-[25px] text-white" />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="text-lg font-semibold text-gray-800">Create a Story</div>
        <div className="text-sm font-normal text-gray-500">
          Create impactful stories using data-driven, interactive presentation editor.
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      title={title}
      okLabel="Create"
      className="w-[512px]"
      okDisabled={isCreating}
      onDone={handleSubmit(onSubmit)}
      onCloseRequest={onCloseRequest}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="flex grow flex-col gap-6">
        <div>
          <label htmlFor="title" className="mb-2 block text-sm font-semibold text-gray-900">
            Name
          </label>
          <input
            autoFocus
            id="title"
            placeholder="e.g. Campaign Targets"
            className="border-primary-600 block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 outline-none focus:border"
            {...register('title', { required: 'Name is required' })}
          />
          {errors.title && <span className="text-red-400">{errors.title.message}</span>}
        </div>
        <Controller
          name="projectId"
          control={control}
          rules={{ required: 'Project is required' }}
          render={({ field }) => (
            <div>
              <label htmlFor="title" className="mb-2 block text-sm font-semibold text-gray-900">
                Project
              </label>
              <ProjectsPicker onSelect={(x) => field.onChange(x.id)} value={field.value} />
              {errors.projectId && <span className="text-red-400">{errors.projectId.message}</span>}
            </div>
          )}
        />
        {!mapContextId && (
          <Controller
            name="defaultMapId"
            control={control}
            rules={{ required: 'Map is required' }}
            render={({ field }) => (
              <div>
                <label htmlFor="title" className="mb-2 block text-sm font-semibold text-gray-900">
                  Start with...
                </label>
                {/*<DefaultMapPicker activeMapId={field.value} onSelect={(x) => field.onChange(x.id)} />*/}
                {errors.defaultMapId && <span className="text-red-400">{errors.defaultMapId.message}</span>}
              </div>
            )}
          />
        )}
      </form>
    </Modal>
  );
};

export default CreateStoryModal;
